import './IntegratedAppsView.scss';

import { AddApp } from './add-app/AddApp';
import { AppMonitorsList } from './app-monitors';
import { AsyncStateNotification } from '@ui/notifications';
import { createAsyncSelectors } from '@lib/selectors';
import { IntegratedApps } from './IntegratedApps';
import React from 'react';

import { BASE_ROUTES, COPY_GENERIC, FULL_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
import { FullUserBoundary, ViewArea } from '@ui/general';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

const postAppMonitorSelectors = createAsyncSelectors((state) => state.core.dataSecurity.monitors.post);

export const IntegratedAppsView: React.FC = () => {
	const location = useLocation();

	return (
		<>
			<ViewArea
				className='add-app-view-area'
				collapseSidebar
				direction='horizontal'
				fullWidth
				id='data-security'>
				<Routes>
					<Route
						element={ <IntegratedApps /> }
						path='' />
					<Route
						element={
							<FullUserBoundary redirect={ FULL_ROUTES.DATA_SECURITY_APPLICATION_SETUP }>
								<AddApp />
							</FullUserBoundary>
						}
						path={ BASE_ROUTES.ADD_APP } />
					<Route
						element={ <AppMonitorsList key={ location.pathname } /> }
						path={ PARAMS.ID } />
					<Route
						element={ <Navigate to={ FULL_ROUTES.DATA_SECURITY } /> }
						path='*' />
				</Routes>
			</ViewArea>
			<AsyncStateNotification
				errored={ COPY_GENERIC.CONTACT_SUPPORT }
				failed={ COPY_GENERIC.CONTACT_SUPPORT }
				stateSelector={ postAppMonitorSelectors.state } />
		</>);
};
